/* Cübe Quadros — Favoritos (v1)
   Guarda apenas HANDLES de produto no localStorage.
   NÃO toca no carrinho da Shopify nem no checkout Yampi.
   Falha silenciosa: qualquer erro aqui não pode quebrar a página. */
(function () {
  'use strict';

  if (window.CubeFavoritos) { return; }

  var CHAVE = 'cube_favoritos_v1';

  /* A página /pages/meus-favoritos já está com o Modelo "favoritos" definido
     no admin, então não é mais preciso forçar o template pela URL (?view=). */
  var URL_PAGINA = '/pages/meus-favoritos';

  var CORACAO = 'M12 20.7s-7.3-4.6-9.2-8.7A5.2 5.2 0 0 1 12 6.4a5.2 5.2 0 0 1 9.2 5.6c-1.9 4.1-9.2 8.7-9.2 8.7z';

  /* ---------- armazenamento ---------- */

  function ler() {
    try {
      var bruto = window.localStorage.getItem(CHAVE);
      if (!bruto) return [];
      var lista = JSON.parse(bruto);
      return Object.prototype.toString.call(lista) === '[object Array]' ? lista : [];
    } catch (e) { return []; }
  }

  function salvar(lista) {
    try { window.localStorage.setItem(CHAVE, JSON.stringify(lista)); } catch (e) {}
  }

  function tem(handle) { return ler().indexOf(handle) !== -1; }

  function alternar(handle) {
    var lista = ler();
    var i = lista.indexOf(handle);
    if (i === -1) { lista.push(handle); } else { lista.splice(i, 1); }
    salvar(lista);
    return lista.indexOf(handle) !== -1;
  }

  function remover(handle) {
    var lista = ler();
    var i = lista.indexOf(handle);
    if (i !== -1) { lista.splice(i, 1); salvar(lista); }
  }

  /* ---------- ícone no cabeçalho ---------- */

  function montarIconeCabecalho() {
    try {
      if (document.querySelector('.cube-fav-header')) return;

      var carrinho = document.querySelector('.header__secondary-links .header__icon-list a[href*="/cart"]');
      if (!carrinho || !carrinho.parentNode) return;

      var a = document.createElement('a');
      a.href = URL_PAGINA;
      a.className = carrinho.className + ' cube-fav-header';
      a.setAttribute('aria-label', 'Meus favoritos');
      a.setAttribute('data-no-instant', '');
      a.removeAttribute('is');
      a.innerHTML =
        '<svg class="cube-fav-header__icone" viewBox="0 0 24 24" aria-hidden="true"><path d="' + CORACAO + '"/></svg>' +
        '<span class="cube-fav-header__bolha" data-fav-contador aria-hidden="true" style="display:none">0</span>';

      carrinho.parentNode.insertBefore(a, carrinho);
    } catch (e) {}
  }

  /* ---------- botão na página de produto ----------
     Montado por JS para não precisar reescrever product-info.liquid (24KB).
     Escopo restrito à seção principal do produto: assim o quick-view (que
     também contém formulário de produto) não recebe um botão com handle errado. */

  function handleDaUrl() {
    try {
      var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) { return null; }
  }

  function montarBotaoProduto() {
    try {
      var tipo = window.themeVariables && window.themeVariables.settings
        ? window.themeVariables.settings.pageType : null;
      if (tipo !== 'product') return;

      var secao = document.querySelector('.shopify-section--main-product');
      if (!secao) return;
      if (secao.querySelector('.cube-fav-btn--inline')) return;

      var handle = handleDaUrl();
      if (!handle) return;

      var ancora = secao.querySelector('.product-form__payment-container')
        || secao.querySelector('form[is="product-form"]')
        || secao.querySelector('.product-form');
      if (!ancora || !ancora.parentNode) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cube-fav-btn cube-fav-btn--inline';
      btn.setAttribute('data-fav-handle', handle);
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', 'Salvar nos favoritos');
      btn.style.marginTop = '10px';
      btn.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + CORACAO + '"/></svg>' +
        '<span class="cube-fav-txt">Salvar nos favoritos</span>';

      ancora.parentNode.insertBefore(btn, ancora.nextSibling);
    } catch (e) {}
  }

  /* ---------- aviso rápido ---------- */

  var avisoTimer = null;

  function mostrarAviso(salvo) {
    try {
      var el = document.querySelector('.cube-fav-aviso');
      if (!el) {
        el = document.createElement('div');
        el.className = 'cube-fav-aviso';
        el.setAttribute('role', 'status');
        document.body.appendChild(el);
      }

      el.innerHTML = salvo
        ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + CORACAO + '"/></svg>' +
          '<span>Salvo nos favoritos</span>' +
          '<a href="' + URL_PAGINA + '">Ver lista</a>'
        : '<span>Removido dos favoritos</span>';

      requestAnimationFrame(function () { el.classList.add('is-visivel'); });

      if (avisoTimer) clearTimeout(avisoTimer);
      avisoTimer = setTimeout(function () {
        el.classList.remove('is-visivel');
      }, salvo ? 3600 : 2000);
    } catch (e) {}
  }

  /* ---------- estado visual ---------- */

  function pintarBotoes() {
    try {
      var lista = ler();
      var botoes = document.querySelectorAll('[data-fav-handle]');
      for (var i = 0; i < botoes.length; i++) {
        var h = botoes[i].getAttribute('data-fav-handle');
        var ativo = lista.indexOf(h) !== -1;
        if (ativo) { botoes[i].classList.add('is-fav'); } else { botoes[i].classList.remove('is-fav'); }
        botoes[i].setAttribute('aria-pressed', ativo ? 'true' : 'false');
        botoes[i].setAttribute('aria-label', ativo ? 'Remover dos favoritos' : 'Salvar nos favoritos');
        var txt = botoes[i].querySelector('.cube-fav-txt');
        if (txt) { txt.textContent = ativo ? 'Salvo nos favoritos' : 'Salvar nos favoritos'; }
      }
    } catch (e) {}
  }

  function atualizarContador() {
    try {
      var n = ler().length;
      var els = document.querySelectorAll('[data-fav-contador]');
      for (var i = 0; i < els.length; i++) {
        els[i].textContent = n;
        els[i].style.display = n > 0 ? '' : 'none';
      }
    } catch (e) {}
  }

  function atualizar() {
    montarIconeCabecalho();
    montarBotaoProduto();
    pintarBotoes();
    atualizarContador();
  }

  /* ---------- cliques ---------- */

  function acharBotao(alvo) {
    var el = alvo;
    while (el && el !== document) {
      if (el.getAttribute && el.getAttribute('data-fav-handle') !== null) return el;
      el = el.parentNode;
    }
    return null;
  }

  document.addEventListener('click', function (ev) {
    try {
      var btn = acharBotao(ev.target);
      if (!btn) return;
      ev.preventDefault();
      ev.stopPropagation();

      var salvo = alternar(btn.getAttribute('data-fav-handle'));
      atualizar();
      mostrarAviso(salvo);

      var icone = document.querySelector('.cube-fav-header');
      if (icone && salvo) {
        icone.classList.remove('cube-fav-header--pulso');
        void icone.offsetWidth;
        icone.classList.add('cube-fav-header--pulso');
      }

      try { document.dispatchEvent(new CustomEvent('cube:favoritos:mudou')); } catch (e2) {}
    } catch (e) {}
  }, true);

  /* ---------- API pública ---------- */

  window.CubeFavoritos = {
    ler: ler, tem: tem, alternar: alternar, remover: remover,
    atualizar: atualizar, urlPagina: URL_PAGINA
  };

  /* ---------- inicialização ---------- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', atualizar);
  } else {
    atualizar();
  }

  /* Vitrines e páginas que trocam conteúdo por AJAX (filtros, quick-view,
     troca de variante) reconstroem o DOM. Este observador recria os botões. */
  try {
    if (document.body && window.MutationObserver) {
      var pendente = null;
      new MutationObserver(function () {
        if (pendente) return;
        pendente = setTimeout(function () {
          pendente = null;
          montarIconeCabecalho();
          montarBotaoProduto();
          pintarBotoes();
          atualizarContador();
        }, 140);
      }).observe(document.body, { childList: true, subtree: true });
    }
  } catch (e) {}
})();
